export const MOCK_STOCK_POSITIONS = [
  {
    id: 1,
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Coimbatore Central Warehouse",
    category: "Electrical Equipment",
    totalStock: 460,
    reservedStock: 300,
    maintenanceReserve: 20,
    defectiveStock: 40,
    listPrice: 2944,
    lastOutwardMovementDate: "2026-07-20", // Active (<180 days)
    reorderQuantity: 80,
  },
  {
    id: 2,
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Peelamedu Depot",
    category: "Electrical Equipment",
    totalStock: 100,
    reservedStock: 0,
    maintenanceReserve: 0,
    defectiveStock: 0,
    listPrice: 640,
    lastOutwardMovementDate: "2026-07-25", // Active
    reorderQuantity: 20,
  },
  {
    id: 3,
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    warehouse: "Warehouse Bangalore",
    category: "Pumps & Hydraulics",
    totalStock: 50,
    reservedStock: 15,
    maintenanceReserve: 5,
    defectiveStock: 2,
    listPrice: 12500,
    lastOutwardMovementDate: "2025-11-12", // Dead (>180 days)
    reorderQuantity: 40, // Available = 28 <= reorder -> Items Below Reorder
  },
  {
    id: 4,
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    warehouse: "Warehouse Mysore",
    category: "Pumps & Hydraulics",
    totalStock: 120,
    reservedStock: 90,
    maintenanceReserve: 10,
    defectiveStock: 25,
    listPrice: 12500,
    lastOutwardMovementDate: "2026-06-18", // Active
    reorderQuantity: 30, // Available = 0 <= reorder (Never negative) -> Items Below Reorder
  },
  {
    id: 5,
    productId: "prod-103",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    warehouse: "Warehouse Chennai",
    category: "Valves & Fittings",
    totalStock: 340,
    reservedStock: 120,
    maintenanceReserve: 15,
    defectiveStock: 5,
    listPrice: 4200,
    lastOutwardMovementDate: "2025-12-05", // Dead
    reorderQuantity: 50,
  },
  {
    id: 6,
    productId: "prod-104",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    warehouse: "Warehouse Bangalore",
    category: "Lighting & Fixtures",
    totalStock: 800,
    reservedStock: 500,
    maintenanceReserve: 50,
    defectiveStock: 10,
    listPrice: 450,
    lastOutwardMovementDate: "2026-07-02", // Active
    reorderQuantity: 100,
  },
  {
    id: 7,
    productId: "prod-105",
    productName: "Rotary Air Compressor 10HP",
    partNumber: "AC-ROT-10H",
    warehouse: "Coimbatore Central Warehouse",
    category: "Pneumatics",
    totalStock: 8,
    reservedStock: 2,
    maintenanceReserve: 1,
    defectiveStock: 0,
    listPrice: 85000,
    lastOutwardMovementDate: "2026-05-15", // Active
    reorderQuantity: 2,
  },
  {
    id: 8,
    productId: "prod-106",
    productName: "Flexible Copper Cable 4 sq mm",
    partNumber: "CB-COP-04S",
    warehouse: "Peelamedu Depot",
    category: "Electrical Equipment",
    totalStock: 1500,
    reservedStock: 1200,
    maintenanceReserve: 0,
    defectiveStock: 0,
    listPrice: 75,
    lastOutwardMovementDate: "2025-10-22", // Dead
    reorderQuantity: 400, // Available = 300 <= reorder -> Items Below Reorder
  },
  {
    id: 9,
    productId: "prod-107",
    productName: "Pressure Gauge 0-10 Bar",
    partNumber: "IN-PGAU-010",
    warehouse: "Warehouse Mysore",
    category: "Instrumentation",
    totalStock: 75,
    reservedStock: 20,
    maintenanceReserve: 10,
    defectiveStock: 5,
    listPrice: 1800,
    lastOutwardMovementDate: "2026-07-10", // Active
    reorderQuantity: 15,
  },
  {
    id: 10,
    productId: "prod-108",
    productName: "Solenoid Valve 24V DC",
    partNumber: "FL-SOLV-24V",
    warehouse: "Warehouse Chennai",
    category: "Valves & Fittings",
    totalStock: 210,
    reservedStock: 80,
    maintenanceReserve: 0,
    defectiveStock: 15,
    listPrice: 3100,
    lastOutwardMovementDate: "2026-01-30", // Dead
    reorderQuantity: 50,
  },
  {
    id: 11,
    productId: "prod-109",
    productName: "Industrial Exhaust Fan 18 Inch",
    partNumber: "LT-EXH-18I",
    warehouse: "Warehouse Bangalore",
    category: "Lighting & Fixtures",
    totalStock: 40,
    reservedStock: 25,
    maintenanceReserve: 2,
    defectiveStock: 0,
    listPrice: 5800,
    lastOutwardMovementDate: "2026-07-29", // Active
    reorderQuantity: 10,
  },
  {
    id: 12,
    productId: "prod-110",
    productName: "Digital Multimeter CAT III",
    partNumber: "IN-MULT-C3",
    warehouse: "Warehouse Mysore",
    category: "Instrumentation",
    totalStock: 15,
    reservedStock: 5,
    maintenanceReserve: 2,
    defectiveStock: 0,
    listPrice: 9200,
    lastOutwardMovementDate: "2026-06-11", // Active
    reorderQuantity: 3,
  },
  {
    id: 13,
    productId: "prod-111",
    productName: "Hydraulic Oil ISO VG 46",
    partNumber: "CH-HYD-VG46",
    warehouse: "Warehouse Chennai",
    category: "Chemicals & Lubricants",
    totalStock: 600,
    reservedStock: 100,
    maintenanceReserve: 40,
    defectiveStock: 10,
    listPrice: 280,
    lastOutwardMovementDate: "2026-07-28", // Active
    reorderQuantity: 100,
  },
  {
    id: 14,
    productId: "prod-112",
    productName: "Distribution Board 12-Way",
    partNumber: "LS-DBRD-12W",
    warehouse: "Coimbatore Central Warehouse",
    category: "Electrical Equipment",
    totalStock: 35,
    reservedStock: 10,
    maintenanceReserve: 5,
    defectiveStock: 2,
    listPrice: 5200,
    lastOutwardMovementDate: "2025-08-14", // Dead
    reorderQuantity: 10,
  },
  {
    id: 15,
    productId: "prod-113",
    productName: "Stainless Steel Bolt M12",
    partNumber: "FL-BOLT-M12",
    warehouse: "Peelamedu Depot",
    category: "Valves & Fittings",
    totalStock: 5000,
    reservedStock: 2000,
    maintenanceReserve: 100,
    defectiveStock: 50,
    listPrice: 15,
    lastOutwardMovementDate: "2026-07-30", // Active
    reorderQuantity: 1000,
  },
];
